<template>
    <div class="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
        <div class="bg-blue-700 overflow-hidden shadow rounded-lg">
            <loading :status="stats.open_tickets == null"/>
            <div class="px-4 py-5 sm:p-6">
                <dt class="text-lg font-semibold text-white truncate">
                    {{ $t('Open Invoices') }}
                </dt>
                <dd class="mt-1 text-3xl font-semibold text-white">
                    {{ stats.open_tickets ? stats.open_tickets : 0 }}
                </dd>
            </div>
        </div>
        <div class="bg-yellow-400 overflow-hidden shadow rounded-lg">
            <loading :status="stats.pending_tickets == null"/>
            <div class="px-4 py-5 sm:p-6">
                <dt class="text-lg font-semibold text-white truncate">
                    {{ $t('Pending Invoices') }}
                </dt>
                <dd class="mt-1 text-3xl font-semibold text-white">
                    {{ stats.pending_tickets ? stats.pending_tickets : 0 }}
                </dd>
            </div>
        </div>
        <div class="bg-green-600 overflow-hidden shadow rounded-lg">
            <loading :status="stats.solved_tickets == null"/>
            <div class="px-4 py-5 sm:p-6">
                <dt class="text-lg font-semibold text-white truncate">
                    {{ $t('Solved Invoices') }}
                </dt>
                <dd class="mt-1 text-3xl font-semibold text-white">
                    {{ stats.solved_tickets ? stats.solved_tickets : 0 }}
                </dd>
            </div>
        </div>
        <div class="bg-red-700 overflow-hidden shadow rounded-lg">
            <loading :status="stats.without_agent == null"/>
            <div class="px-4 py-5 sm:p-6">
                <dt class="text-lg font-semibold text-white truncate">
                    {{ $t('Rejected Invoices') }}
                </dt>
                <dd class="mt-1 text-3xl font-semibold text-white">
                    {{ stats.without_agent ? stats.without_agent : 0 }}
                </dd>
            </div>
        </div>
        <div class="bg-blue-400 overflow-hidden shadow rounded-lg">
            <loading :status="stats.registredPhamacies == null"/>
            <div class="px-4 py-5 sm:p-6">
                <dt class="text-lg font-semibold text-white truncate">
                    {{ $t('Registered Pharmacies') }}
                </dt>
                <dd class="mt-1 text-3xl font-semibold text-white">
                    {{ stats.registredPhamacies ? stats.registredPhamacies : 0 }}
                </dd>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "stats",
    data() {
        return {
            stats: {
                open_tickets: null,
                pending_tickets: null,
                solved_tickets: null,
                without_agent: null,
                numberOfUsers: null,
                registredPhamacies:null,
            }
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            const self = this;
            axios.get('api/dashboard/stats/count').then(function (response) {
                self.stats = response.data;
            });
        }
    },
}
</script>
